import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import image from './klt@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="kowloon-tong-community">
    <h1>Kowloon Tong Community</h1>
    <p>
      Kingston International School is located in the heart of Kowloon Tong, a neighbourhood rich in culture and
      history. Set at the foot of Lion Rock, Kingston is nestled within a few minutes walk radius from temples, parks,
      other prestigious educational institutions and low rise housing. The wide sidewalks and trees that line the
      streets make it an ideal neighbourhood to take a stroll and soak in the atmosphere. Kowloon Tong is a unique
      community with many streets named after British counties. When visiting Kingston, make sure not to miss the some
      of the highlights of our wonderful Kowloon Tong Community.
    </p>
    <img src={image} alt="Kowloon Tong Community" />
  </ContentLayout>
);
